import React from 'react';
import "./ShopLocation.css";

const ShopLocation = () => {
  return (
    <div className='strategic-location-container'>
      <h3>Shop <strong>Location</strong></h3>
      <p>The geographical location of the business is a strategic decision, <strong>essential for its viability and performance.</strong></p>

      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <div className="section-heading">
              <h2>Get in touch with us!</h2>
              <div className="line-shape"></div>
            </div>

            <div className="address-text">
              <p><i className="fa fa-map-marker pr-2" aria-hidden="true"></i> <span>Address :</span> Kurukathani - Kottakkal Rd, Choothupara,<br /> Kottakkal, Kerala 676503</p>
            </div>
            <div className="phone-text">
              <p><i className="fa fa-volume-control-phone pr-2" aria-hidden="true"></i> <span>Phone :</span> +91 90377 19855</p>
            </div>
            <div className="email-text">
              <p><i className="fa fa-envelope-o pr-2" aria-hidden="true"></i><span>Email :</span> vhavilmilk@gmail.com</p>
            </div>
          </div>
          <div className="col-md-6">
            <div className="map wow fadeInRightBig" style={{ visibility: 'visible', animationName: 'fadeInRightBig' }}>
              <iframe className="scale" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15666.038474149638!2d75.9956335!3d11.0003388!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x7d23edbd1c459afb!2sV.H%20Avil%20Milk!5e0!3m2!1sen!2sin!4v1614574981706!5m2!1sen!2sin" width="100%" height="310px" style={{ border: '0', filter: 'invert(90%)' }} allowFullScreen="" loading="lazy"></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShopLocation;
